module.exports = __webpack_public_path__ + "static/media/finish_sound.c08e7b1e.m4a";